import { useDispatch } from "react-redux"
import { startNewChat } from "store/app/app.actions";

export const useStartNewChat = () => {
    const dispatch = useDispatch();
    
    return () => {
        dispatch(startNewChat())
    }
}